import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import {
    getRoles,
    getUser,
    updateUser,
    deleteUser,
    addCardToUser,
    removeCardFromUser,
    getUserCards, getUserLocation, getUserLocations, addLocationToUser, removeLocationFromUser
} from "../api/userapi";
import DataCard from "../components/DataCard";
import Tabs from "../components/Tabs";
import DataTable from "../components/DataTable";
import {fetchCards} from "../api/cardapi";
import CustomModal from "../components/CustomModal";
import {fetchLocations} from "../api/locationApi"; // 👈 new reusable Tabs


export default function UserProfile() {
    const { id } = useParams();
    const { token } = useAuth();
    const [user, setUser] = useState(null);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const resUser = await getUser(id);
            const resRoles = await getRoles();
            if (resUser?.success) setUser(resUser.data);
            if (resRoles?.success) setRoles(resRoles.data);
            setLoading(false);
        })();
    }, [id, token]);

    if (loading) return <p>Loading user...</p>;
    if (!user) return <p>No user found.</p>;

    const handleChange = (key, value) => {
        setUser((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = () => updateUser(user);

    const handleRemove = () => {
        deleteUser(id).then(() => {
            if (window.history.length > 1) navigate(-1);
            else navigate("/users");
        });
    };

    return (
        <div className="container mt-4">
            <DataCard
                title="User Profile"
                edit
                remove
                onRemove={handleRemove}
                onSave={handleSave}
                onChange={handleChange}
                items={[
                    { label: "Name", value: user.Name, editable: true },
                    { label: "Phone", value: user.Phone, editable: true },
                    {
                        label: "Role",
                        key: "Role",
                        value: user.Role,
                        editable: true,
                        format: {
                            type: "select",
                            options: {
                                source: roles,
                                key: "RoleID",
                                value: "Title",
                            },
                        },
                    },
                    { label: "Created", value: user.created_at },
                    { label: "Updated", value: user.updated_at },
                ]}
            />

            <Tabs
                tabs={[
                    { key: "cards", label: "Cards", component: <UserCardsTable userId={id} /> },
                    { key: "employment", label: "Employment", component: <UserEmploymentTable userId={id} /> },
                ]}
            />
        </div>
    );
}


function UserCardsTable({ userId }) {
    const navigate = useNavigate();
    const [cards, setCards] = useState([]);
    const [addCard, setAddCard] = useState(false);

    const loadCards = async () => {
        const res = await getUserCards(userId);
        setCards(res?.data ?? []);
    };

    useEffect(() => {
        loadCards();
    }, [userId]);

    const handleAddCard = async (card) => {
        await addCardToUser(userId, card.CardID);
        setAddCard(false);
        loadCards();
    };

    const handleRemoveCard = async (card) => {
        await removeCardFromUser(userId, card.CardID);
        loadCards();
    };

    return (
        <>
            <DataTable
                title="Cards"
                columns={[{ key: "Name", label: "Title", searchable: true }]}
                data={cards}
                add
                remove
                onAdd={() => setAddCard(true)}
                onRemove={handleRemoveCard}
                onRowClick={(card) => navigate("/cards/" + card.CardID)}
            />

            {addCard && (
                <AddCardModal show={addCard} onClose={() => setAddCard(false)} onAdd={handleAddCard} />
            )}
        </>
    );
}

function AddCardModal({ show, onClose, onAdd }) {
    const [availableCards, setAvailableCards] = useState([]);

    useEffect(() => {
        if (show) fetchCards().then((r) => setAvailableCards(r.data ?? []));
    }, [show]);

    const handleRowClick = (row) => {
        onAdd(row);
        onClose();
    };

    return (
        <CustomModal title="Add Card to User" show={show} onClose={onClose}>
            <DataTable
                title="Available Cards"
                columns={[{ key: "Name", label: "Card", searchable: true }]}
                data={availableCards}
                onRowClick={handleRowClick}
            />
        </CustomModal>
    );
}


function UserEmploymentTable({ userId }) {
    const [locations, setLocations] = useState([]);
    const [showAddLocation, setShowAddLocation] = useState(false);
    const navigate = useNavigate();

    const fetchData = () => {
        getUserLocations(userId).then((r)=>setLocations(r.data ?? []))
    }
    useEffect(() => {
        fetchData()
    }, [userId]);

    const handleAddLocation = (location) =>{
        addLocationToUser(userId,location.LocationID).then(fetchData)
    }

    const handleRemoveLocation = (location) => {
        removeLocationFromUser(userId, location.LocationID).then(fetchData)
    }

    return (<>
        <DataTable
            title="Employment"
            add
            remove
            columns={[
                { key: "Name", label: "Location", searchable: true },
            ]}
            onAdd={()=>{setShowAddLocation(true)}}
            onRemove={handleRemoveLocation}
            data={locations}
            onRowClick={(loc) => navigate("/locations/" + loc.LocationID)}
        />
            <AddEmploymentModal onAdd={handleAddLocation} onClose={()=>{setShowAddLocation(false)}} show={showAddLocation}/>
        </>
    );
}

function AddEmploymentModal({show, onClose, onAdd}) {
    const [locations, setLocations] = useState([])

    useEffect(() => {
    }, [locations]);

    useEffect(() => {
        fetchLocations().then((r)=>setLocations(r.data ?? []))
    }, []);

    const handleRowClick = (row) => {
        onAdd(row);
        onClose()
    }

    return (
        <CustomModal title="Add Employment" show={show} onClose={onClose}>
            <DataTable
                data={locations}
                columns={[{key: "Name",label: "Location" }]}
                onRowClick={handleRowClick}
            />
        </CustomModal>
    )
}


